import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Modal, Table, Spin, Tooltip, Button } from "antd";
import "../../styles/Dashboard.css";
import newStyled from "@emotion/styled";
import { useEffect, useState } from "react";
import { base_url } from "../../utils/apiConfig";
import axios from "axios";
import { EyeOutlined } from "@ant-design/icons";



ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Legend,
  ChartDataLabels
);
const StoreWiseLostMarksBarChart = ({ isModalOpen, questionId, closeModal }) => {
  const [questionData, setQuestionData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!questionId) return;

    const fetchSelectedData = async () => {
      setIsLoading(true);

      try {
        const token = localStorage.getItem("authToken");

        const response = await axios.get(
          `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/dashboard/question/${questionId}/improvable_question_list`,
          {
            headers: {
              Authorization: `Token ${token}`,
            },
          }
        );

        setQuestionData(Object.values(response.data.reports || {}));
      } catch (err) {
        console.error(err);
        setQuestionData([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSelectedData();
  }, [questionId]);

  const columns = [
    {
      title: "Store Name",
      dataIndex: "store_name",
      align: "center",

    },
    {
      title: "Max Marks",
      dataIndex: "max_marks",
      align: "center",
    },
    {
      title: "Obtained",
      dataIndex: "marks_obtained",
      align: "center",
    },
    {
      title: "Lost",
      dataIndex: "lost_marks",
      align: "center",
    },
    {
      title: "Lost %",
      align: "center",
      render: (_, record) => <div style={{ textAlign: "center", backgroundColor: "#cd5c5c", color: "#fff", padding: "5px 10px", borderRadius: "4px" }}>
        {((record.lost_marks / record.max_marks) * 100).toFixed(1)}%
      </div>
    },
    {
      title: "Action",
      align: "center",
      render: (_, record) => (
        <BtnStyle
          style={{
            fontSize: "1rem",
            padding: "8px",
            backgroundColor: "#007dc1",
            color: "#fff",
          }}
          onClick={() => {
            // console.log(`View all sections for store: ${record.store_name}`);
            window.open(`/auditReport/${record.audit_store_id}`, "_blank");
          }}
        >
          <EyeOutlined size={"medium"} />
        </BtnStyle>
      )
    },
  ];

  const dataSource = questionData.map((data) => ({
    key: data.audit_store_id,
    ...data,
  }));

  return (
    <ModalStl
      title="Improvement Areas Based on Store-wise Lost Marks"
      open={isModalOpen}
      onCancel={closeModal}
      footer={null}
      width={900}
      styles={{
        body: {
          maxHeight: "75vh",
          overflowY: "auto",
        }
      }}
    >
      {isLoading ? (
        <div style={{ textAlign: "center", padding: "50px 0" }}>
          <Spin size="large" />
        </div>
      ) : (
        <TableStyle
          dataSource={dataSource}
          columns={columns}
          rowKey={(record) => record.audit_store_id}
          pagination={false}
          bordered={true}
          rowClassName={() => "custom-row"}
        />
      )}
    </ModalStl>
  );
};

const TableStyle = newStyled(Table)`
.centered-column {
    text-align: center !important; 
  }

 :where(.css-dev-only-do-not-override-1kf000u).ant-table-wrapper table {
    width: 100%;
    text-align: start;
    border-radius: 8px 8px 0 0;
    border-spacing: 0;
  }

 :where(.css-dev-only-do-not-override-1kf000u).ant-table-wrapper .ant-table-thead > tr > th,
 :where(.css-dev-only-do-not-override-1kf000u).ant-table-wrapper .ant-table-tbody > tr > td {
    border: 1px solid #dde1e6 !important;
  }

 :where(.css-dev-only-do-not-override-1kf000u).ant-table-wrapper .ant-table-thead >tr>th, :where(.css-dev-only-do-not-override-1kf000u).ant-table-wrapper .ant-table-thead >tr>td {
    color: #000 !important;
     font-size:1.1rem !important;
   font-family:'Roboto', sans-serif !important;
    background: rgb(242,242,242) !important;
  }

`;

const ModalStl = newStyled(Modal)`
:where(.css-dev-only-do-not-override-1kf000u).ant-modal .ant-modal-title {
color: #003C5D !important;
font-size:1.5rem !important;
font-family:'Roboto', sans-serif !important;
}
`;


const BtnStyle = newStyled(Button)`
:where(.css-dev-only-do-not-override-1kf000u).ant-btn-variant-solid{
 background-color: #007dc1 !important;
}
`;
export default StoreWiseLostMarksBarChart;
